import { SalesforceServices } from '@clearkit/icons';
import { CKSelectNext } from 'clearkit';

import { CustomObject } from '~/generated/graphql';

function toSelectableItem(object: CustomObject) {
  return {
    value: object.id,
    label: object.externalObjectName,
  };
}

type SelectCustomObjectProps = {
  label?: string;
  items: CustomObject[];
  value?: CustomObject;
  onChange: (newObject?: CustomObject) => void;
};
export function SelectCustomObject({
  items,
  value,
  onChange,
  label,
}: SelectCustomObjectProps) {
  return (
    <CKSelectNext
      items={items.map(toSelectableItem)}
      onChange={({ value }) => {
        const object = items.find((obj: CustomObject) => obj.id === value);
        onChange(object);
      }}
      placeholder="Choose a custom object to be enriched"
      value={value && toSelectableItem(value)}
    >
      <CKSelectNext.Label className="font-medium">{label}</CKSelectNext.Label>
      <CKSelectNext.IconLeft>
        <SalesforceServices />
      </CKSelectNext.IconLeft>
    </CKSelectNext>
  );
}
